import { render } from "./AccountingCategory.vue?vue&type=template&id=08e5ed5a"
import script from "./AccountingCategory.vue?vue&type=script&lang=js"
export * from "./AccountingCategory.vue?vue&type=script&lang=js"

import "./AccountingCategory.vue?vue&type=style&index=0&id=08e5ed5a&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__